import { FaLock, FaUserClock, FaKey, FaUserShield } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaLock />, // Lock icon
    title: 'Security Expertise',
    description: 'Utilizing advanced security technology for maximum protection',
  },
  {
    id: 2,
    icon: <FaUserClock />, // User Clock icon
    title: 'Rapid Response',
    description: 'Swift and reliable assistance in emergency lockout situations 24/7',
  },
  {
    id: 3,
    icon: <FaKey />, // Key icon
    title: 'Key Solutions',
    description: 'Providing key cutting and duplication services for convenience',
  },
  {
    id: 4,
    icon: <FaUserShield />, // User Shield icon
    title: 'Trustworthy Service',
    description: 'Committed to integrity and customer satisfaction in every interaction',
  },
];

export default features;